import { Component, ElementRef, ViewChild } from '@angular/core';
import { CustomerType, PageBase, CustomerInfo } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';
import { CustomerDialog } from '../../../../t4common/dialogs/CustomerDialog/CustomerDialog';
import { NewCompanyDialog } from '../../dialogs/NewCompanyDialog/NewCompanyDialog';




@Component({
  selector: 'company-customers',
  styleUrls: ['./companyCustomers.component.css'],
  templateUrl: './companyCustomers.component.html',
})
export class CompanyCustomersComponent extends PageBase {

    @ViewChild("datatable", {static: false}) table: T4DatatableWidget;
    public customerType = CustomerType;

    constructor(el: ElementRef) {
      super(el, "CompanyList");
    }

    public update() {
        this.table.update();
  }

  public async createCompanyCustomer() {
    var customer = await this.UI.openDialog<CustomerInfo>("T4.Bookings.NewCompanyDialog", { data: null });
    if (customer) {
      if (!customer?.Id) {
        await CustomerDialog.open(this.Dialog, new CustomerInfo(), null, 'new');
      }
      else {
        await CustomerDialog.open(this.Dialog, customer, customer?.Id);
      }
    }
    this.table.update();
  }
}
